import { styled } from "@material-ui/core/styles";
import CloseIcon from '@material-ui/icons/Close';
import { div, Flex } from "lqx-react/lib";
import React from "react";
import { ComputedFieldItem } from "../../models/import-template-details";

export const ComputedSelectOption = ({ computedFieldItem, onDeleteComputed }
  : { computedFieldItem: ComputedFieldItem, onDeleteComputed?: any }) => {

  return (
    <FlexComputedOption row>
      <ComputedFieldColumn>{computedFieldItem.field1.name}</ComputedFieldColumn>
      <OperatorComputedFieldColumn>{computedFieldItem.operator}</OperatorComputedFieldColumn>
      <ComputedFieldColumn>{computedFieldItem.field2.name}</ComputedFieldColumn>
      <ComputedFieldColumn>{computedFieldItem.resultField.name}</ComputedFieldColumn>
      <ComputedFieldColumn>
        <CloseBtn>
          <CloseIcon onClick={() => onDeleteComputed(computedFieldItem.field1.id, computedFieldItem.field2.id, computedFieldItem.resultField.id )} />
        </CloseBtn>
      </ComputedFieldColumn>
    </FlexComputedOption>
  );
};

const FlexComputedOption = styled(Flex)({
  background: 'whitesmoke',
  padding: '5px 0 5px 5px',
  marginBottom: '4px',
  borderRadius: '5px'
})

const FieldColumn = div({
  display: 'flex',
  flexDirection: 'column',
  color: '#668AA5',
  fontSize: '14px',
  fontFamily: 'Montserrat',
  fontWeight: 500
})

const ComputedFieldColumn = styled(FieldColumn)({
  flex: '0 0 115px',
  color: '#767D84',

})

const OperatorComputedFieldColumn = styled(FieldColumn)({
  flex: '0 0 100px',
  color: '#767D84',
  fontFamily: 'Montserrat',
  fontWeight: 500
})

const CloseBtn = div({
  marginTop: '5px',
  height: '22px',
  marginLeft: '5px',
  cursor: 'pointer'
});